/**
 * Initials fallback shared by every avatar/logo tile that can't load an image.
 * One implementation so "SS" means the same thing everywhere.
 */

/** First letters of up to two name parts, e.g. "Sai Sandesh" -> "SS". */
export function getInitials(name: string | null | undefined): string {
  return (name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export default { getInitials };
